import { useRef, useState } from 'react';
import { useCategoryFilter } from '@components/ProductOffers/configuration/steps/TVAddOnsStep/useCategoryFilter';
import type { ParsedAddOn } from '@t/addOn.types';

export const useAddOnTabs = (themePackages: ParsedAddOn[], individualChannels: ParsedAddOn[]) => {
  const [activeTab, setActiveTab] = useState(0);
  const scrollRef = useRef<HTMLDivElement>(null);

  const activeAddOns = activeTab === 0 ? themePackages : individualChannels;
  const { category, setCategory, categoryOptions, categorySelectWidth, filteredChannels, resetCategory } =
    useCategoryFilter(activeAddOns);

  const handleTabChange = (_: React.SyntheticEvent, value: number) => {
    setActiveTab(value);
    resetCategory();
    scrollRef.current?.scrollTo(0, 0);
  };

  return { activeTab, handleTabChange, scrollRef, category, setCategory, categoryOptions, categorySelectWidth, filteredChannels };
};
